export enum TradingLimitType {
    SellMaxBondSize = 1,
    SellMaxDailyTradesSize = 2,
    BuyMaxBondSize = 3,
    BuyMaxDailyTradesSize = 4
}
